export default __webpack_public_path__ + "static/media/loans.f8a50e12.svg";